/* AutosTW custom — product compare (learn from bobjane.com.au).
   Card "Compare" toggles store a full product snapshot in localStorage, so the
   sticky bar + comparison modal render fully client-side (no API calls). */
const KEY = 'atw_compare_v1';
const MAX = 3;

function load() {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
}
function save(items) {
  try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
}

class CompareBar extends HTMLElement {
  connectedCallback() {
    this.items = load();
    this.bar = this.querySelector('.atw-cbar');
    this.slots = this.querySelector('.atw-cbar__slots');
    this.count = this.querySelector('.atw-cbar__count');
    this.openBtn = this.querySelector('.atw-cbar__open');
    this.clearBtn = this.querySelector('.atw-cbar__clear');
    this.modal = this.querySelector('.atw-cmodal');
    this.modalBody = this.querySelector('.atw-cmodal__body');

    // Delegated toggle clicks (cards can be re-rendered by filters/section API)
    document.addEventListener('click', (e) => {
      const t = e.target.closest('.atw-compare-toggle');
      if (t) { e.preventDefault(); e.stopPropagation(); this.toggle(t); return; }
    });
    this.openBtn.addEventListener('click', () => this.openModal());
    this.clearBtn.addEventListener('click', () => this.clearAll());
    this.querySelectorAll('[data-cmodal-close]').forEach((el) =>
      el.addEventListener('click', () => this.closeModal()));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeModal(); });

    this.renderBar();
    this.syncToggles();
  }

  productFromBtn(btn) {
    const d = btn.dataset;
    return {
      handle: d.handle, url: d.url, title: d.title, image: d.image || '',
      price: d.price || '', compare: d.compare || '', set4: d.set4 || '',
      available: d.available === '1', vid: d.vid || '', brand: d.brand || '', size: d.size || ''
    };
  }

  toggle(btn) {
    const p = this.productFromBtn(btn);
    if (!p.handle) return;
    const i = this.items.findIndex((x) => x.handle === p.handle);
    if (i > -1) {
      this.items.splice(i, 1);
    } else {
      if (this.items.length >= MAX) { this.flashLimit(); return; }
      this.items.push(p);
    }
    save(this.items);
    this.renderBar();
    this.syncToggles();
  }

  remove(handle) {
    this.items = this.items.filter((x) => x.handle !== handle);
    save(this.items);
    this.renderBar();
    this.syncToggles();
    if (this.items.length < 2) this.closeModal();
    else if (this.modal.classList.contains('is-open')) this.renderModal();
  }

  clearAll() {
    this.items = [];
    save(this.items);
    this.renderBar();
    this.syncToggles();
    this.closeModal();
  }

  syncToggles() {
    const set = new Set(this.items.map((x) => x.handle));
    document.querySelectorAll('.atw-compare-toggle').forEach((btn) => {
      const on = set.has(btn.dataset.handle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-selected', on);
      const label = btn.querySelector('.atw-compare-label');
      if (label) label.textContent = on ? 'Added' : 'Compare';
    });
  }

  renderBar() {
    const n = this.items.length;
    this.bar.classList.toggle('is-hidden', n === 0);
    this.count.textContent = `Compare: ${n}/${MAX}`;
    this.openBtn.disabled = n < 2;
    let html = '';
    for (let i = 0; i < MAX; i++) {
      const p = this.items[i];
      if (p) {
        html += `<div class="atw-cbar__slot">
          <button class="atw-cbar__rm" data-rm="${p.handle}" aria-label="Remove ${p.title}">&times;</button>
          <div class="atw-cbar__thumb">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</div>
          <span class="atw-cbar__name">${p.title}</span>
        </div>`;
      } else {
        html += `<div class="atw-cbar__slot atw-cbar__slot--empty"><span>+ Add tyre</span></div>`;
      }
    }
    this.slots.innerHTML = html;
    this.slots.querySelectorAll('[data-rm]').forEach((b) =>
      b.addEventListener('click', () => this.remove(b.dataset.rm)));
  }

  flashLimit() {
    this.bar.classList.remove('is-hidden');
    this.bar.classList.add('atw-cbar--limit');
    setTimeout(() => this.bar.classList.remove('atw-cbar--limit'), 600);
  }

  openModal() {
    if (this.items.length < 2) return;
    this.renderModal();
    this.modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  closeModal() {
    this.modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  renderModal() {
    const items = this.items;
    const cols = items.map((p) => `
      <th scope="col">
        <div class="atw-cmodal__prod">
          <div class="atw-cmodal__imgwrap">
            ${p.image ? `<img src="${p.image}" alt="${p.title}">` : ''}
            <button class="atw-cmodal__rm" data-rm="${p.handle}" aria-label="Remove ${p.title}">&times;</button>
          </div>
          <a href="${p.url}" class="atw-cmodal__ptitle">${p.title}</a>
        </div>
      </th>`).join('');

    const row = (label, fn) =>
      `<tr><th scope="row">${label}</th>${items.map((p) => `<td>${fn(p)}</td>`).join('')}</tr>`;

    const priceCell = (p) => `<span class="atw-cmodal__price">${p.price || '—'}</span>` +
      (p.compare ? ` <s>${p.compare}</s>` : '');

    this.modalBody.innerHTML = `
      <div class="atw-cmodal__scroll">
      <table class="atw-cmodal__table">
        <thead><tr><th class="atw-cmodal__corner"></th>${cols}</tr></thead>
        <tbody>
          ${row('Brand', (p) => p.brand || '—')}
          ${row('Size', (p) => p.size || '—')}
          ${row('Price (per tyre)', priceCell)}
          ${row('Set of 4', (p) => p.set4 || '—')}
          ${row('Availability', (p) => p.available
            ? '<span class="atw-cmodal__yes">In stock</span>'
            : '<span class="atw-cmodal__no">Enquire</span>')}
          ${row('', (p) => `<a class="atw-cmodal__view" href="${p.url}">View tyre</a>` +
            (p.available && p.vid
              ? `<button class="atw-cmodal__add" data-add="${p.vid}">Add to cart</button>` : ''))}
        </tbody>
      </table></div>`;

    this.modalBody.querySelectorAll('[data-rm]').forEach((b) =>
      b.addEventListener('click', () => this.remove(b.dataset.rm)));
    this.modalBody.querySelectorAll('[data-add]').forEach((b) =>
      b.addEventListener('click', () => this.addToCart(b.dataset.add, b)));
  }

  addToCart(vid, btn) {
    btn.disabled = true; btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(vid), quantity: 1 })
    }).then((r) => r.ok ? (window.location.href = '/cart') : Promise.reject())
      .catch(() => { btn.disabled = false; btn.textContent = 'Add to cart'; });
  }
}

if (!customElements.get('compare-bar')) {
  customElements.define('compare-bar', CompareBar);
}
